import { Button } from "@material-ui/core";
import { buildFreeMessage, buildQAFormLiveChat, buildQAFormMessage, buildTheEndMessage, checkDataChangeInChatbot, checkMessageOutOfSession, createMessageList, postMessage } from "./handler/ChatBoxHandler";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePreviewSettingAtom } from "@/state/atom/chatBotPreview";
import Constant from "@/common/constant/Constant";
import { v4 as uuidv4} from 'uuid';
import LoadingMessage from "./LoadingMessage";
import React, { memo } from 'react';
import Utils from "@/common/utils/utils";
import { createKibanaDataEnquete } from "@/component/system/logKibanaHandler/LogKibanaHandler";
import LogKibanaConstant from "@/common/constant/LogKibanaConstant";
import { createKibanaLogAPI } from "@/service/logKibanaService";
import trI18n from '@/common/utils/trI18n';

function ConfirmMessage({
    message,
    setMessages,
    settingChatBot,
    messages,
    supportThreadIdState,
    affiliationOrganization,
    isModePreview,
    setIsShowModalReload,
    projectAlias,
    subDomain,
    listCategories,
    isMaximizedPanel,
    projectId,
    isIframeChatBot,
    projectInuseDetail,
    currentCorporationDetail,
    isChatRobo,
    API,
    isEnableMsgInput,
    setIsEnableMsgInput,
    getMessage,
    resolvedMessages
}) {
    const [messageState, setMessagesState] = useState(message)
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessageContent, setFreeMessageContent] = useState('')
    const [actionWhenNotResolve, setActionWhenNotResolve] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabledButton, setIsDisableButton] = useState(false);

    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    useEffect(() => {
        if (!isModePreview) {
            setFreeMessageContent(settingChatBot.freeMsg);
            setActionWhenNotResolve(settingChatBot?.actionWhenNotResolve)
        }
    }, [settingChatBot]);

    useEffect(() => {
        if (isModePreview) {
           if(previewSetting.freeMsg !== freeMessageContent){
                setFreeMessageContent(previewSetting.freeMsg)
           }
           if(previewSetting.actionWhenNotResolve !== actionWhenNotResolve){
                setActionWhenNotResolve(previewSetting.actionWhenNotResolve)
           }
        }
    }, [previewSetting]);

    const logEnquete = (enqueteResult) => {
        let qaCategory = getQaCategory(messages, messageState);
        let tagGroup = getTagGroupName();
        let selectTag = getSelectTagNames();
        let dataLog = {
            qaCategory: qaCategory,
            enqueteResult: enqueteResult,
            enqueteFor: hasAIChatInSession() ? LogKibanaConstant.ENQUETE_FOR.AI : LogKibanaConstant.ENQUETE_FOR.ROBO,
            tagGroup: tagGroup,
            selectTag: selectTag,
            aiChatInquiryText: getLastAIChatInquiry().substring(0, 5000),
            aiChatAnswerText: getLastAIChatAnswer().substring(0, 5000),
            searchCondition: [qaCategory, selectTag].filter(s => s).join(' ')
        };
        let logKibanaData = createKibanaDataEnquete(dataLog, currentCorporationDetail, projectInuseDetail);
        let param = {
            logType: LogKibanaConstant.KNOWLEDGE_ROBO.ENQUETE,
            logKibanaData: logKibanaData
        };
        createKibanaLogAPI(API, param);
    };

    const onClickYesHandler = () => {
        if (!isModePreview) {
            if (isMsgContentEnquete(messageState)) {
                logEnquete(trI18n('COMBTN002'));
            }
        }
        
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const newMessage = buildTheEndMessage(0, messageState.content[0]?.formQASystem, resolvedMessages);
        postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
        setMessages(pev => [...pev, newMessage]);
        setIsEnableMsgInput(false)
    };

    const onClickNoHandler = async () => {
        setIsDisableButton(true);
        if (!isModePreview) {
            if (isMsgContentEnquete(messageState)) {
                logEnquete(trI18n('COMBTN007'));
            }
        }
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        if(!isModePreview) {
            let validatedChangeData = await checkDataChangeInChatbot(projectAlias, subDomain, settingChatBot, messageState?.content[0]?.categoryIdSelected, listCategories, projectId, isIframeChatBot);
            if (
                !validatedChangeData.status && Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)
                ) {
                setIsShowModalReload(true);
                return;
            }
            if(!validatedChangeData.status && !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)) {
                let optionsWhennotResolved = validatedChangeData?.chatbotSettingNew?.actionWhenNotResolve;
                renderMessageByOptions(optionsWhennotResolved);
                setIsDisableButton(false);
                setIsShowModalReload(true);
                return;
            }
        }

        renderMessageByOptions(actionWhenNotResolve);
        setIsDisableButton(false);
        setIsEnableMsgInput(false)
    };
    
    const renderMessageByOptions = (optionsWhennotResolved) => {
        switch(optionsWhennotResolved) {
            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                let idQALivechat = `qaform_${uuidv4()}`
                let dataLiveChat = {
                    isDefault: false,
                    idQA: idQALivechat,
                    categoryIdSelected: message.content[0]?.categoryIdSelected,
                    formQASystem: message.content[0]?.formQASystem
                };
                const newMessages = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                postMessage(newMessages, supportThreadIdState, affiliationOrganization,false,isModePreview, idQALivechat);
                setMessages(pev => [...pev, newMessages]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                let idQA = `qaform_${uuidv4()}`
                let data = {
                    isDefault: false,
                    idQA: idQA,
                    data: {
                        categoryIdSelected: messageState.content[0]?.categoryIdSelected,
                        formQASystem: messageState.content[0]?.formQASystem
                    }
                };
                const newMessage = buildQAFormMessage(data, resolvedMessages);
                postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview, idQA);
                setMessages(pev => [...pev, newMessage]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                const freeMessage = buildFreeMessage(freeMessageContent,0);
                const theEndMessage = buildTheEndMessage(1, messageState.content[0]?.formQASystem, resolvedMessages);
                createMessageList(
                    [freeMessage, theEndMessage],
                    supportThreadIdState,
                    affiliationOrganization,
                    isModePreview
                );
                setMessages(pev => [...pev, freeMessage, theEndMessage]);
                break;

            default:
                break;
        }
    }

    const isMsgContentEnquete = (msg) => {
        if (!Utils.isEmptyArray(msg?.content)) {
            let msgKeyContent = msg?.content[0];
            if (msgKeyContent?.msgKey === trI18n('CBOTLB001')) {
                return true;
            }
        }
        return false;
    }

    const getQaCategory = (listMsg, msgSelect) => {
        let categoryId = msgSelect?.content[0].categoryIdSelected;
        let qaCategory = '';
        let msgEnquete = listMsg.find(msg => msg?.idOfOption === categoryId);
        if (msgEnquete) {
            qaCategory = msgEnquete?.content;
        }
        return qaCategory;
    }

    // Check if there is at least one AI chat message in the current session
    const hasAIChatInSession = () => {
        return messages.some(
            msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI
        );
    };

    // Get index of the last category selection message for current category
    const getLastCategoryMessageIndex = () => {
        const categoryId = messageState?.content[0]?.categoryIdSelected;
        if (!categoryId) return -1;
        for (let i = messages.length - 1; i >= 0; i--) {
            if (messages[i].messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_CATEGORY
                && messages[i].idOfOption === categoryId) {
                return i;
            }
        }
        return -1;
    };

    // Get all selected tag group (field) names from messages, unique + sorted (only within current category scope)
    const getTagGroupName = () => {
        const categoryIdx = getLastCategoryMessageIndex();
        const scopedMessages = categoryIdx >= 0 ? messages.slice(categoryIdx) : messages;
        const tagItemMessages = scopedMessages.filter(
            msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM && msg.isFromMe
        );
        const fieldNames = [...new Set(tagItemMessages.map(msg => msg.nameOfTagField).filter(c => c))];
        return fieldNames.sort().join(' ');
    };

    // Get all selected tag names from messages (format: tag@fieldName, sorted alphabetically, only within current category scope)
    const getSelectTagNames = () => {
        const categoryIdx = getLastCategoryMessageIndex();
        const scopedMessages = categoryIdx >= 0 ? messages.slice(categoryIdx) : messages;
        const tagItemMessages = scopedMessages.filter(
            msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM && msg.isFromMe
        );
        if (Utils.isEmptyArray(tagItemMessages)) return '';
        return tagItemMessages
            .map(msg => {
                const tagName = msg.content;
                const fieldName = msg.nameOfTagField;
                if (!tagName) return '';
                return fieldName ? `${tagName}@${fieldName}` : tagName;
            })
            .filter(c => c)
            .sort()
            .join(' ');
    };

    // Get last AI chat inquiry text
    const getLastAIChatInquiry = () => {
        const lastInquiry = [...messages]
            .reverse()
            .find(msg => msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.USER_SEND_CHAT_AI);
        return lastInquiry?.content || '';
    };

    // Get last AI chat answer text, strip HTML
    const getLastAIChatAnswer = () => {
        const lastAnswer = [...messages]
            .reverse()
            .find(msg =>
                msg.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE
                && !msg.isLoadingMessage
            );
        if (!lastAnswer?.content) return '';
        return lastAnswer.content.replace(/<[^>]*>/g, '').trim();
    };

    return (
        <>
            <div
                className={
                    isMaximizedPanel
                        ? 'message-text confirm-message maximized-form-text'
                        : 'message-text confirm-message'
                }
            >
                <div className="text-question">{getMessage('bot_confirm_resolved')}</div>
                <Button onClick={onClickYesHandler} className="confirm-resolved">
                    {getMessage('bot_confirm_yes_label')}
                </Button>
                <Button
                    onClick={onClickNoHandler}
                    className="confirm-unresolved"
                    disabled={isDisabledButton}
                >
                    {getMessage('bot_confirm_no_label')}
                </Button>
                <div className="text-question" style={{fontSize: '10px'}}>{message?.messageChatAI}</div>
            </div>
            {isLoading && (
                <div className="message-text">
                    <LoadingMessage />
                </div>
            )}
        </>
    );
}

export default memo(ConfirmMessage);